import { displayControlRef } from "../../lib/controlRef";
import type { ControlGroupDef } from "../FrameworkControlList";

// Every ISO management system standard shares the harmonised structure (Annex SL): clauses 4 to
// 10 carry the same titles in ISO 27001, 9001, 42001, 45001 and 14001. The clause pages group
// their requirements by it, so the group headers read the same on every ISO standard.

export const HARMONISED_CLAUSES: Array<{ num: number; title: string }> = [
  { num: 4, title: "Context of the organization" },
  { num: 5, title: "Leadership" },
  { num: 6, title: "Planning" },
  { num: 7, title: "Support" },
  { num: 8, title: "Operation" },
  { num: 9, title: "Performance evaluation" },
  { num: 10, title: "Improvement" },
];

/** "iso9001-7.5" / "7.5" -> 7. */
export function clauseNumber(controlId: string): number | null {
  const m = displayControlRef(controlId).match(/^(\d+)(?:\.|$)/);
  return m ? parseInt(m[1], 10) : null;
}

/** Groups for a clause page: "Clause 7: Support", with the page's own one-line summary as the hint. */
export function isoClauseGroups(
  summaries: Partial<Record<number, string>> = {},
  /** A standard that retitles a harmonised clause (ISO 45001 clause 5 adds worker participation). */
  titles: Partial<Record<number, string>> = {},
): ControlGroupDef[] {
  return HARMONISED_CLAUSES.map((c) => ({
    key: `clause-${c.num}`,
    title: `Clause ${c.num}: ${titles[c.num] ?? c.title}`,
    hint: summaries[c.num],
    match: (row) => clauseNumber(row.control.id) === c.num,
  }));
}
